import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Image from './Image';
import Link from './Link';

const propTypes = {
    items: PropTypes.array.isRequired,
    vertical: PropTypes.bool,
};

const defaultProps = {
    items: [
        {
            id: 33,
            media: {
                url: '/img/placeholders/quote.jpg',
            },
            title: 'About stuff',
            icon: 'video',
            route: '/the-film/news',
            quote: 'This is a quote',
        },
        {
            id: 22,
            media: {
                url: '/img/placeholders/bigquote.jpg',
            },
            route: '/first-hand-experiences/quotes',
            quote: 'This is a quote again',
        },
    ],
    vertical: true,
};

class Gallery extends Component {

    constructor(props) {
        super(props);
        this.renderGallerySection = this.renderGallerySection.bind(this);
    }

    renderGallerySection(item) {
        const { vertical } = this.props;

        const className = classNames({
            icon: true,
            [item.icon ? item.icon : 'empty']: true,
            colored: true,
        });

        const quote = item.quote ? (
            <p className="quote">{`"${item.quote}"`}</p>
        ) : null;

        return (
            <div key={`gallery_link_${item.id}`} className="gallery-section">
                <Link to={item.route} className="page-link">
                    <Image media={item.media} background />
                    { vertical ? (
                        quote
                    ) : (
                        <div>
                            <h4 className="text small font-inline"><span className={className} />{item.title}</h4>
                            <p className="text">{item.description}</p>
                        </div>
                    ) }
                </Link>
            </div>
        );
    }

    render() {
        const { items } = this.props;
        return (
            <div className="partial partial-subpages">
                { items.map(this.renderGallerySection) }
            </div>
        );
    }
}

Gallery.propTypes = propTypes;
Gallery.defaultProps = defaultProps;

export default Gallery;



// WEBPACK FOOTER //
// ./components/partials/Gallery.jsx